import React, { useEffect, useRef, useState } from "react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { TiArrowSortedUp } from "react-icons/ti";
import { chartTableBgColor, chartThemeThresholds } from "../index";
import Moment from "react-moment";
import CustomSpinLoader from "../../../../../components/CustomSpinLoader";

const statusMap = {
  Bad: 2,
  Average: 1,
};

const getIndex = (value, key) => {
  if(key === "Status"){
    return statusMap[value] ?? 0;
  }
  const num = (typeof value === "string")
  ? parseFloat(value.replace("%", ""))
  : value;
  if (num > 7) return 2;
  if (num > 3) return 1;
  return 0;
};

const TableList = ({ data, heading, date, isCart =true, size, handleReq = null, url=null, loading=false }) => {

  const headingsToCheck = {
    "total production by item": 1,
    "total production by discard": 1,
    "total stock in hand": 1,
    "brand wise sales": 1,
    "top 5 categories": 1,
    "top 5 branches wise performance": 1,
    "forecasting": 1,
    "brach wise variance heat map": 1,
    "recipe compliance": 1,
    "branch wise performance": 1,
    "top recipe variances": 1
  };

  const styleApplyCheck = {
    "Brach Wise Variance Heat Map": {"all" : 1},
    "Branch Wise Performance": { "Variance %": 1, "Status": 1},
  };

  const headingsToStyle = {
    "top 5 categories": 1,
    "top 5 branches wise performance": 1,
    "forecasting": 1
  };

  const [loadAll,setLoadAll] = useState(false);
  const [dataBody,setDataBody] = useState([]);
  const [dataHead,setDataHead] = useState([]);
  const [tableLoading,setTableLoading] = useState(false);
  const componentRef = useRef();
  const getReport= (e)=>{
    componentRef.current.handleDownload();
  }

  const handleLoad = () =>{
    setDataHead(data?.[0] ? Object.keys(data[0]) : [])
    if(loadAll === true){
      setTableLoading(true);
      setDataBody(data);
      setTimeout(() => {    
        setTableLoading(false);
      }, 300);
    }else{
      setTableLoading(true);
      Array.isArray(data) && setDataBody(data.slice(0, 5));
      setTimeout(() => {    
        setTableLoading(false);
      }, 300);
    }
  }
 
  useEffect(()=>{
    const header = heading && heading?.toLowerCase();
    const loadData = headingsToCheck[header];
    if(data){
      if(header === "forecasting"){
        data.sort((a, b) => parseFloat(a["Qty Available Today"])-parseFloat(b["Qty Available Today"]));
      }
      if(loadData){
        handleLoad()
      }
    }
 },[loadAll,data])

  return (
    <div className={`col ${isCart ? "mt-3" : "mt-1"} px-2 position-relative ${size}`}>
     <div className={`${isCart ? "dashboard__card_list" : "" }`}>
      <ReactHTMLTableToExcel
      id="table-xls-button"
      className="download-table-xls-button btn btn-success float-right mr-3 invisible"
      table={heading}
      filename={heading}
      sheet="sheet 1"
      buttonText="Sales Detail"
      ref={componentRef}
      />
      <div className="row mb-2 pr-2">
        <div className="list-heading font-weight-bold col-6">
          {heading ? <h5 className="mt-1 mb-2">{heading}</h5> : ""}
          {
            heading.toLowerCase() === "forecasting" && (
              <div className="table-text" style={{marginTop:"-0.25rem", lineHeight:"1.1rem"}}>Forecast Daily Food Consumption With Precision. Plan Inventory And Reduce Waste Efficiently.</div>
            )
          }
        </div>
        <div className="col-6 d-flex align-items-center justify-content-end">
       
        {data && data?.length > 5 &&
          <button className="btn btn-primary btn-sm table-text rounded px-2 mr-2"
          disabled={tableLoading}
          onClick={()=> setLoadAll(!loadAll)}
          >
            {loadAll ? "Load less" : "Load All"}
          </button>
        }
        {
          data && data?.length > 0 && (
            <button
            className="btn btn-primary text-uppercase btn-sm table-text px-2 rounded"
            onClick={(e) => getReport(e)}
            >
            <i class="fa fa-table mr-1" aria-hidden="true"></i>
              download 
            </button>
          )
        }
        </div>
      </div>
      {data && dataHead?.length > 0 ? (
          <div className="col-12">
            <div key={dataBody?.length} className="production-table-view" data-simplebar style={{height: headingsToStyle[heading?.toLowerCase()] ? "14.5rem" : "15.5rem"}}>
              <table id={heading} className="table mb-0 table-borderless">
                {
                  date?.startDate && date?.endDate && (
                    <tr className="d-none"> 
                      <th colSpan={dataHead?.length}>
                        <h3 className="text-center mt-0">
                          {heading}
                        </h3>
                        <p className="text-center">
                          FROM&nbsp;
                          <Moment format="LL">
                            {date.startDate}
                          </Moment>
                          &nbsp;TO&nbsp;
                          <Moment format="LL">{date.endDate}</Moment>
                        </p>
                      </th>
                    </tr>
                  )
                }
                {
                  data && data?.length > 0 && (
                    <>
                      <thead className={!headingsToStyle[heading?.toLowerCase()] ? "production_table_head" : ""}>
                        <tr className="sticky-top" style={{top:"-1px"}}>
                          {
                          dataHead?.length && dataHead.map((item)=>{
                            return(
                              <th
                              scope="col"
                              className="list-head-text text-capitalize dashboard_border border-1 p-2 table_child_token"
                              >
                                {item}
                                {
                                  item === "Total" &&
                                  <TiArrowSortedUp className = "dashboard_table_sort cursor-pointer" onClick={()=>{
                                    const sorting = [...dataBody].sort((a,b)=>{
                                      return parseFloat(a.Total) - parseFloat(b.Total);
                                    });
                                    setTimeout(() => {
                                      setDataBody(sorting);
                                    }, 200);
                                  }}/>
                                }
                              </th>
                            )
                          })
                          }
                        </tr>
                      </thead>
                      <tbody>
                      {dataBody?.length && dataBody?.map((dataChild) => {
                        return(
                          <tr>
                            {dataHead.map((key,i) => {
                              const value = dataChild[key];
                              const isValidNumber = value !== null && value !== "" && value !== "-" && !isNaN(value);
                              const table = isValidNumber ? Number(Number(value).toFixed(2)) : ((value === "-" || !value) ? "-" : value);
                              let color = "";
                              let bgColor = "";
                              if(i > 0 && styleApplyCheck[heading] && (styleApplyCheck[heading]["all"] || styleApplyCheck[heading][key])){
                                const ind = getIndex(value,key);
                                color = chartThemeThresholds[ind];
                                bgColor = chartTableBgColor[ind]
                              }

                              return (
                                <td
                                  style={{background: bgColor, color: color}}
                                  scope="col"
                                  className={`list-text text-capitalize dashboard_border border-1 p-2 `}
                                >
                                  {table}
                                </td>
                              );
                            })}
                          </tr>
                        )
                       })}
                      </tbody>
                    </>
                  )
                }
              </table>
            </div>
          </div>
        ) : (
          <div className="btn_load btn_load_height">
           {
            loading ? (
              <>
              {/*loading */}
              <CustomSpinLoader loading={loading}/>
              </>
            ) : (
                url ?
                  <button className="btn btn-sm btn-primary rounded-md" onClick={()=> url && handleReq(url)}>Load Data</button>
                : "No Data Available"
            )}
          </div>
      )}
     </div> 
    </div>
  );
};

export default TableList;
